module.exports = __webpack_public_path__ + "static/media/ic_trusted_green.33eda0c0.svg";